//system
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, HttpServiceConfig } from './common/http.service';
import { HttpHeaders } from '@angular/common/http';

//services
import { LogService } from './common/log.service';

//models
import { OpenGraphMetadata, InviteCode, InviteCodeGenerateRequest, InviteCodeRedeemRequest } from 'src/app/models/invite-code';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class InviteCodeService {

  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  async getInviteCode(inviteCode: string): Promise<InviteCode> {
    return await this.httpService.getPromise<InviteCode>(`InviteCode/ByCode/${inviteCode}`);
  }

  async getOpenGraphMetadata(inviteCode: string): Promise<OpenGraphMetadata> {
    return await this.httpService.getPromise<OpenGraphMetadata>(`InviteCode/OpenGraphMetadata/${inviteCode}`);
  }

  generateInviteCode(inviteCodeGenerateRequest: InviteCodeGenerateRequest): Observable<InviteCode> {
    return this.httpService.post<InviteCode>(`InviteCode/Generate`, inviteCodeGenerateRequest);
  }

  redeemInviteCode(inviteCodeRedeemRequest: InviteCodeRedeemRequest): Observable<InviteCode | string> {
    return this.httpService.post<InviteCode | string>(`InviteCode/Redeem`, inviteCodeRedeemRequest, new HttpHeaders(), true);
  }
}
